import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PhoneComponent, SdvorButtonComponent } from '@sdvor/shared/ui/v2';

@Component({
  selector: 'sd-no-shops',
  imports: [RouterLink, SdvorButtonComponent, PhoneComponent],
  templateUrl: './no-shops.component.html',
  styleUrls: ['./no-shops.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoShopsComponent {}
